var _a;
import { StoresWidgetID, VIEWER_SCRIPT_DSN } from '../constants';
export var CART_ICON_DSN = 'https://2e72459978a94fb9a2797c603da9aa56@sentry.wixpress.com/79';
export var GALLERY_PAGE_DSN = 'https://388906b36558481d9b876003bd47bfad@sentry.wixpress.com/80';
export var SLIDER_GALLERY_DSN = 'https://3a92bd21fb6e4f0daba05af7fa3f30fc@sentry.wixpress.com/83';
export var PRODUCT_PAGE_DSN = 'https://e6dce12cedda447d9b2c6b902092a485@sentry.wixpress.com/81';
export var PRODUCT_WIDGET_DSN = 'https://3a5d9be8e5fd408090c8c3e78ce7cbcb@sentry.wixpress.com/82';
export var THANK_YOU_PAGE_DSN = VIEWER_SCRIPT_DSN;
export var sentryConfPerController = (_a = {},
    _a[StoresWidgetID.CART_ICON] = CART_ICON_DSN,
    _a[StoresWidgetID.PRODUCT_PAGE] = PRODUCT_PAGE_DSN,
    _a[StoresWidgetID.GALLERY_PAGE] = GALLERY_PAGE_DSN,
    _a[StoresWidgetID.GRID_GALLERY] = GALLERY_PAGE_DSN,
    _a[StoresWidgetID.SLIDER_GALLERY] = SLIDER_GALLERY_DSN,
    _a[StoresWidgetID.PRODUCT_WIDGET] = PRODUCT_WIDGET_DSN,
    _a[StoresWidgetID.THANK_YOU_PAGE] = THANK_YOU_PAGE_DSN,
    _a);
//# sourceMappingURL=sentryConf.js.map